// ============================================================
//  CONTRACT ADDRESSES per network.
//  Fill in your deployed Evitta + USDT addresses here.
// ============================================================
import { ACTIVE_NETWORK } from './networks';
import EvittaAbi from './abi/Evitta.json';
import ERC20Abi from './abi/ERC20.json';

const ADDRESSES = {
  mainnet: {
    evitta: '0x17389Fa7158a019e21F5C48bc6680D45922cCE9a', // <-- mainnet Evitta
    usdt: '0x55d398326f99059fF775485246999027B3197955', // BSC USDT (18 decimals)
  },
  testnet: {
    evitta: '0x4e35b00efb854c33491bebec5aacfaa77d62bfe8', // <-- testnet Evitta
    usdt: '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC', // <-- testnet USDT (18 decimals)
  },
};

export const CONTRACTS = ADDRESSES[ACTIVE_NETWORK];
export const EVITTA_ABI = EvittaAbi;
export const ERC20_ABI = ERC20Abi;

// USDT on BSC uses 18 decimals (unlike ETH USDT which is 6).
export const USDT_DECIMALS = 18;

// Default referrer id used by the contract when none is provided.
export const DEFAULT_REFERRER = 100000;

// Package catalog (price in whole USDT, must match contract packagePrices).
export const PACKAGES = [
  { id: 1, price: 2, name: 'Starter' },
  { id: 2, price: 4, name: 'Bronze' },
  { id: 3, price: 8, name: 'Silver' },
  { id: 4, price: 16, name: 'Gold' },
  { id: 5, price: 32, name: 'Platinum' },
  { id: 6, price: 64, name: 'Diamond' },
  { id: 7, price: 128, name: 'Crown' },
  { id: 8, price: 256, name: 'Royal' },
  { id: 9, price: 512, name: 'Legend' },
];

// Total to activate all 9 packages in one shot (DIAMOND_TOTAL).
export const ALL_PACKAGES_TOTAL = 1022;
